export const GHS_PICTOGRAM_VALUES = [
  "ghs01",
  "ghs02",
  "ghs03",
  "ghs04",
  "ghs05",
  "ghs06",
  "ghs07",
  "ghs08",
  "ghs09",
] as const;

export type GhsPictogram = (typeof GHS_PICTOGRAM_VALUES)[number];

export const GHS_PICTOGRAM_LABELS: Record<GhsPictogram, string> = {
  ghs01: "Exploding bomb",
  ghs02: "Flame",
  ghs03: "Flame over circle",
  ghs04: "Gas cylinder",
  ghs05: "Corrosion",
  ghs06: "Skull and crossbones",
  ghs07: "Exclamation mark",
  ghs08: "Health hazard",
  ghs09: "Environment",
};
